
import styles from './InitialPage.module.scss'

const InitialPage = ({isOpen}) => {

    return (
        <section className={styles.main} >
                <div className={styles.box}>
                    <div className={styles.overlay}>
                        <div className={styles.container}>
                            <h1 className={styles.title}>Производство и&nbsp;поставка полиэтиленовых мешков и&nbsp;пакетов</h1>
                            <div className={styles.box_button}>
                                
                            </div>
                        </div>
                    </div>
                </div>  
        </section>
    )
}

export default InitialPage